import { useQuery } from '@tanstack/react-query';

import { getSettingsHistory } from '~/services/SupportService';

export const settingsHistoryQueryKeys = {
  all: ['settingsHistory'] as const,
  list: () => [...settingsHistoryQueryKeys.all, 'list'] as const,
};

interface UseGetSettingsHistoryParams {
  enabled?: boolean;
}

export function useGetSettingsHistory({ enabled = true }: UseGetSettingsHistoryParams = {}) {
  return useQuery({
    queryKey: settingsHistoryQueryKeys.list(),
    queryFn: async () => {
      const { result } = await getSettingsHistory();
      return result;
    },
    enabled,
  });
}
